import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=720630ce"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ProductCategorySidebar: require('/vercel/path0/components/shared/product-category/ProductCategorySidebar.vue').default,BlogCard: require('/vercel/path0/components/shared/BlogCard.vue').default,ProductCategoryFilter: require('/vercel/path0/components/shared/product-category/ProductCategoryFilter.vue').default,ProductWideCard: require('/vercel/path0/components/shared/ProductWideCard.vue').default,ProductCard: require('/vercel/path0/components/shared/ProductCard.vue').default,ProductCategoryPagination: require('/vercel/path0/components/shared/product-category/ProductCategoryPagination.vue').default,ComponentLoader: require('/vercel/path0/components/ComponentLoader.vue').default,Container: require('/vercel/path0/components/shared/Container.vue').default})
